import {asset} from 'imba';
import url from './trash.svg';
export default asset({
	url: url,
	type: 'svg',
	meta: {"attributes":{"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"},"flags":["feather","feather-trash"],"content":"<polyline points=\"3 6 5 6 21 6\"></polyline><path d=\"M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2\"></path>"},
	toString: function(){ return this.url;}
})